<template>
  <div v-show="loadingCompleted">
    <template v-for="history in pointHistory">
      <div :key="history.order" class="p-3 d-flex align-items-center justify-content-between border-bottom">
        <div class="font-size-md">
          <div class="text-mcf-color">{{ history.name }}</div>
          <div class="font-size-sm text-gray600" v-if="!history.isPositive">{{ history.code }}</div>
          <div class="font-size-sm text-gray600">{{ history.createDate }}</div>
        </div>
        <div class="h5 m-0 font-weight-normal" :class="[history.isPositive ? 'text-customize' : 'text-gray500']">{{ history.value }}</div>
      </div>
    </template>
    <div v-if="hasHistory" class="py-2 text-center bg-gray200 font-size-sm">{{ $t('point-history.bottom-hint') }}</div>
    <div v-if="!hasHistory" class="m-3 rounded-md font-size-md text-center w-50 m-auto">
      <div class="image-panel image-panel-5 bg-none mt-5 mb-2">
        <img :src="emptyHint.img" alt="">
      </div>
      <p class="text-mcf-color">{{ emptyHint.desc }}</p>
    </div>
  </div>
</template>

<script>
import pageSettingGetter from '@/utils/pageSettingGetter';
import dateTimeFormatter from '@/utils/dateTimeFormatter';
import currency from '@/filters/currency';

export default {
  data() {
    return {
      // 資料是否完成載入
      loadingCompleted: false,
      // 積點歷程
      pointHistory: [],
      // 空白頁
      emptyHint: {
        img: '',
        desc: '',
      },
    };
  },
  computed: {
    hasHistory() {
      const vm = this;
      return vm.pointHistory.length > 0;
    },
  },
  created() {
    const vm = this;
    // 取得頁面設定資料
    const getPageSetting = vm.$store.dispatch('getPageSetting', 'UserPointHistory');
    getPageSetting.then((setting) => {
      vm.pointUnit = pageSettingGetter.getFunctionWording(setting, 'UserPointUnit');
      vm.deadlineHintWording = pageSettingGetter.getFunctionWording(setting, 'UserPointDeadlineWording');
      vm.emptyHint.img = pageSettingGetter.getFunction(setting, 'BlankPagePic').picUrl;
      vm.emptyHint.desc = pageSettingGetter.getFunctionWording(setting, 'BlankPageWording');
    });
    // 取得會員積點
    const getMemberBonus = vm.$store.dispatch('getMemberBonus');
    getMemberBonus.then((memberBonus) => {
      const now = new Date();
      const dateLimit = Date.UTC(now.getUTCFullYear(), now.getUTCMonth() - 3, now.getUTCDate(), now.getUTCHours(), now.getUTCMinutes());
      vm.pointHistory = memberBonus.point
        .filter((point) => point.createTime > dateLimit)
        .map((point, index) => {
          const isPositive = point.point >= 0;
          return {
            order: index,
            isPositive,
            name: isPositive ? point.bonusName : point.usingTypeName,
            createDate: dateTimeFormatter.formatTaiwanDateTime(new Date(point.createTime)),
            value: isPositive ? `+${currency(point.point)}` : `${currency(point.point)}`,
            code: point.tradeCode,
          };
        });
    });
    Promise.all([getPageSetting, getMemberBonus])
      .then(() => { vm.loadingCompleted = true; });
  },
};
</script>
